import { render, staticRenderFns } from "./ProductBlocking.vue?vue&type=template&id=0c7d5d57&scoped=true&lang=pug&"
import script from "./ProductBlocking.vue?vue&type=script&lang=ts&"
export * from "./ProductBlocking.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBlocking.vue?vue&type=style&index=0&id=0c7d5d57&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7d5d57",
  null
  
)

export default component.exports